import Axios from "axios";
import {
  SET_BANK_BOOK_REPORT,
  UNSET_BANK_BOOK_REPORT,
} from "@/store/mutation-types";
import {
  getBankBookReport,
} from "@/store/api";

const state = {
  bankBookReport: [],
};

const getters = {
  getBankBookReport(state) {
    return state.bankBookReport;
  },
};

const mutations = {
  [SET_BANK_BOOK_REPORT](state, data) {
    state.bankBookReport = data;
  },
  [UNSET_BANK_BOOK_REPORT](state) {
    state.bankBookReport = [];
  },
};

const actions = {
  getBankBook({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBankBookReport}`, { params: data })
        .then((response) => {
          commit(SET_BANK_BOOK_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_BANK_BOOK_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

